import React from "react";
import AddUserModal from "../../common/addUserModal";
import { createEmployee, updateEmployee } from "../../../services/employee.service";
import { employeeMessages } from "../../../constants/message.constant";

type EmployeeData = {
  id?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  street: string;
  city: string;
  state: string;
  zipcode: string;
};

type AddEmployeeModalProps = {
  open: boolean;
  handleClose: (action?: string) => void;
  businessId: string;
  editMode?: boolean;
  employeeData?: EmployeeData;
};

const AddEmployeeModal = ({
  open,
  handleClose,
  businessId,
  editMode = false,
  employeeData,
}: AddEmployeeModalProps) => {
  return (
    <AddUserModal
      open={open}
      handleClose={handleClose}
      businessId={businessId}
      editMode={editMode}
      userData={employeeData}
      title="Employee"
      createUser={createEmployee}
      updateUser={updateEmployee}
      successMessages={{
        add: employeeMessages.addEmployee,
        edit: employeeMessages.editEmployee,
      }}
    />
  );
};

export default AddEmployeeModal;
